import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { to: "/", label: "Atelier" },
  { to: "/#services", label: "Services" },
  { to: "/#projets", label: "Projets" },
  { to: "/#methode", label: "Méthode" },
  { to: "/journal", label: "Journal" },
  { to: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#FAFAF8]/85 border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="container-max flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-display text-2xl tracking-tight">Maison</span>
          <span className="font-display text-2xl tracking-tight text-terracotta italic">Faubourg</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="overline link-arc text-ink hover:text-terracotta transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:+33184801234"
            data-testid="nav-phone"
            className="flex items-center gap-2 overline text-ink"
          >
            <Phone className="w-3.5 h-3.5" />
            01 84 80 12 34
          </a>
          <a href="/#devis" data-testid="nav-cta-quote" className="btn-sharp">
            Devis offert
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden p-2"
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-bone border-t border-line">
          <div className="container-max py-8 flex flex-col gap-6">
            {links.map((l) => (
              <a
                key={l.to}
                href={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-display text-3xl"
              >
                {l.label}
              </a>
            ))}
            <a href="/#devis" data-testid="nav-mobile-cta" className="btn-sharp w-fit mt-2">
              Devis offert
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
